import React from 'react';
import block from 'bem-cn-lite';
import {ClassNameProps} from '@yandex-data-ui/cloud-components';

import withTranslation, {WithTranslationProps} from 'hoc/withTranslation';

import './EventLabel.scss';

const b = block('EventLabel');

export interface EventLabelProps extends WithTranslationProps, ClassNameProps {
    status: string;
}

const EventLabel: React.FC<EventLabelProps> = ({status, className, i18nK}) => (
    <div className={b({color: status}, className)}>{i18nK(`events-label-${status}`)}</div>
);

export default withTranslation('events')(EventLabel);
